export default __webpack_public_path__ + "static/media/postSuvinil5.bb6c715b.png";